import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../../../../components/TabPanel';

const PATIENT_INFO_TAB = 0;
const REQUEST_INFO_TAB = 1;

class AppointmentRequestViewModal extends Component {
  state = {
    tabPosition: PATIENT_INFO_TAB,
  };

  handleTabPositionChange = (event, newTabPosition) => {
    this.setState({ tabPosition: newTabPosition });
  };

  render() {
    const { tabPosition } = this.state;
    const { request, open, onClose, classes } = this.props;

    return (
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        classes={{ paper: classes.modal }}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <h2>Request Details</h2>
            </Grid>

            <Grid item xs={1}>
              <IconButton aria-label="Close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent classes={{ root: classes.modalContent }}>
          <AppBar position="static" color="default">
            <Tabs value={tabPosition} onChange={this.handleTabPositionChange}>
              <Tab label="Patient" />
              <Tab label="Appointment Request" />
            </Tabs>
          </AppBar>

          {tabPosition === PATIENT_INFO_TAB && (
            <TabPanel>
              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Name"
                name="name"
                value={request.patient.name}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Email"
                name="email"
                value={request.patient.email}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Phone Number"
                name="phone"
                value={request.patient.phone}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Birthdate"
                name="birthdate"
                value={request.patient.birthdate}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Address Line 1"
                name="addressLine1"
                value={request.patient.addressLine1}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Address Line 2"
                name="addressLine2"
                value={request.patient.addressLine2}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="City"
                name="city"
                value={request.patient.city}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="State"
                name="state"
                value={request.patient.state}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Zipcode"
                name="zipcode"
                value={request.patient.zipcode}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Insurance Name"
                name="insuranceName"
                value={request.patient.insuranceName}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Insurance ID"
                name="insuranceId"
                value={request.patient.insuranceId}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Payer ID"
                name="payerId"
                value={request.patient.payerId}
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Group Number"
                name="groupNumber"
                value={request.patient.groupNumber}
                className={classes.input}
              />
            </TabPanel>
          )}

          {tabPosition === REQUEST_INFO_TAB && (
            <TabPanel>
              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Requested By (Name)"
                name="requestedByName"
                value={
                  request.sender.name ? request.sender.name : '"Qwell Search"'
                }
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Requested By (Practice Name)"
                name="requestedByPracticeName"
                value={
                  request.sender.practiceName
                    ? request.sender.practiceName
                    : 'N/A'
                }
                className={classes.input}
              />

              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Requested By (Phone Number)"
                name="phone"
                value={request.sender.phone ? request.sender.phone : 'N/A'}
                className={classes.input}
              />

              <TextField
                fullWidth
                disabled
                multiline
                variant="outlined"
                rows="4"
                label="Reasons for Visit / Notes"
                name="reasonsForVisit"
                value={request.visitReason || request.portalNotes}
                className={classes.input}
              />
            </TabPanel>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
    float: 'right',
  },
  input: {
    margin: '0.5em 0',
  },
});

AppointmentRequestViewModal.propTypes = {
  request: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(AppointmentRequestViewModal);
